import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Textarea from "../components/Textarea";
import "./OpenQuestion.scss";

const OpenQuestion = ({
  question,
  fieldName,
  value,
  error,
  setFieldValue,
  setFieldTouched,
}) => {
  const { t } = useTranslation(["survey"]);
  const handleChange = e => {
    setFieldValue(fieldName, e.target.value);
  };

  const handleBlur = () => {
    setFieldTouched(fieldName, true);
  };

  return (
    <div className="open-question">
      <div className="open-question__header">
        {question.question && (
          <h2 className="open-question__title">
            {question.question}
            {question.required && (
              <span className="open-question__required">*</span>
            )}
          </h2>
        )}
      </div>

      <Textarea
        name={fieldName}
        value={value || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={t("survey:wizard.placeholderOpenQuestion")}
        rows={6}
        className={error ? "open-question__textarea--error" : ""}
      />

      {error && <div className="open-question__error">{error}</div>}
    </div>
  );
};

OpenQuestion.propTypes = {
  question: PropTypes.shape({
    question: PropTypes.string,
    required: PropTypes.bool,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};

OpenQuestion.defaultProps = {
  value: "",
  error: null,
};

export default OpenQuestion;
